import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './P2pTradeSellWaitingBuyer.css';

const mockOrderData = {
  orderId: '4162539730316465',
  buyer: {
    name: 'Ubong Ben',
    initial: 'U',
    verified: true,
    fullName: 'UBONG BEN'
  },
  timeRemaining: 892, // seconds (14:52)
  orderDetails: {
    quantity: '1.00',
    crypto: 'USDT',
    amountFiat: '1430.00',
    currency: 'NGN',
    price: '1430.00',
    priceUnit: 'NGN/USDT'
  }
};

const P2pTradeSellWaitingBuyer: React.FC = () => {
  const navigate = useNavigate();
  const [timeRemaining, setTimeRemaining] = useState(mockOrderData.timeRemaining);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining((prev) => {
        if (prev <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const progressPercentage = (timeRemaining / mockOrderData.timeRemaining) * 100;

  const handleBack = () => {
    navigate(-1);
  };

  const handleChat = () => {
    console.log('Opening chat...');
  };

  const handleCopyOrderId = () => {
    navigator.clipboard.writeText(mockOrderData.orderId);
  };

  const handleCancel = () => {
    console.log('Order cancelled');
  };

  return (
    <div className="waiting-buyer-container">
      <header className="waiting-buyer-header">
        <button className="waiting-buyer-back-button" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <h1 className="waiting-buyer-title">Sell USDT</h1>

        <button className="waiting-buyer-chat-button" onClick={handleChat} aria-label="Chat">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M17 8.5C17 12.366 13.866 15.5 10 15.5C8.95 15.5 7.951 15.28 7.049 14.888L3 16L4.112 11.951C3.72 11.049 3.5 10.05 3.5 9C3.5 5.134 6.634 2 10.5 2C14.366 2 17.5 5.134 17.5 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </header>

      <div className="waiting-buyer-progress-container">
        <div className="waiting-buyer-progress-bar">
          <div 
            className="waiting-buyer-progress-fill" 
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>

      <div className="waiting-buyer-content">
        <div className="waiting-buyer-merchant-card">
          <div className="waiting-buyer-merchant-avatar">
            {mockOrderData.buyer.initial}
          </div>
          
          <div className="waiting-buyer-merchant-info">
            <div className="waiting-buyer-merchant-name">
              {mockOrderData.buyer.name}
              {mockOrderData.buyer.verified && (
                <svg className="waiting-buyer-verified-badge" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 0L11.5 6.5L18 8L11.5 9.5L10 16L8.5 9.5L2 8L8.5 6.5L10 0Z" fill="#22c35d"/>
                </svg>
              )}
            </div>
            <div className="waiting-buyer-merchant-label">Merchant</div>
          </div>

          <h2 className="waiting-buyer-order-heading">Awaiting Payment</h2>
          
          <p className="waiting-buyer-timer-label">
            Waiting for buyer payment initiation
          </p>

          <div className="waiting-buyer-timer-card">
            <div className="waiting-buyer-timer-display">{formatTime(timeRemaining)}</div>
          </div>
        </div>

        <div className="waiting-buyer-order-id-card">
          <div className="waiting-buyer-order-id-label">ID</div>
          <div className="waiting-buyer-order-id-value">{mockOrderData.orderId}</div>
          <button 
            className="waiting-buyer-copy-button" 
            onClick={handleCopyOrderId}
            aria-label="Copy order ID"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M3 11V3C3 2.44772 3.44772 2 4 2H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="waiting-buyer-details-card">
          <div className="waiting-buyer-detail-row">
            <span className="waiting-buyer-detail-label">Quantity</span>
            <div className="waiting-buyer-detail-value-group">
              <span className="waiting-buyer-detail-amount">{mockOrderData.orderDetails.quantity}</span>
              <span className="waiting-buyer-detail-crypto">{mockOrderData.orderDetails.crypto}</span>
            </div>
          </div>

          <div className="waiting-buyer-divider" />

          <div className="waiting-buyer-detail-row">
            <span className="waiting-buyer-detail-label">Amount (Fiat)</span>
            <div className="waiting-buyer-detail-value-group">
              <span className="waiting-buyer-detail-amount">{mockOrderData.orderDetails.amountFiat}</span>
              <span className="waiting-buyer-detail-currency">{mockOrderData.orderDetails.currency}</span>
            </div>
          </div>

          <div className="waiting-buyer-divider" />

          <div className="waiting-buyer-detail-row">
            <span className="waiting-buyer-detail-label">Price</span>
            <div className="waiting-buyer-detail-value-group">
              <span className="waiting-buyer-detail-amount">{mockOrderData.orderDetails.price}</span>
              <span className="waiting-buyer-detail-unit">{mockOrderData.orderDetails.priceUnit}</span>
            </div>
          </div>
        </div>

        <div className="waiting-buyer-merchant-name-card">
          <span className="waiting-buyer-merchant-name-label">Merchant Name</span>
          <span className="waiting-buyer-merchant-name-value">{mockOrderData.buyer.fullName}</span>
        </div>
      </div>

      <div className="waiting-buyer-action-bar">
        <button className="waiting-buyer-waiting-button" disabled>
          Waiting for Buyer Payment
        </button>
        
        <button className="waiting-buyer-cancel-button" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default P2pTradeSellWaitingBuyer;